// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__vBI7J","requiredAsterisk":"Info_requiredAsterisk__CHrzi"};